import { useNavigate } from 'react-router';
import type { ChatMessage } from '../../../stores/chatStore';

interface ForkNoteProps {
  msg: ChatMessage;
}

export function ForkNote({ msg }: ForkNoteProps) {
  const note = msg.forkNote;
  const navigate = useNavigate();
  if (!note) return null;
  return (
    <div className="flex justify-center my-1">
      <button
        type="button"
        onClick={() => navigate(`/chat/${note.toConversationId}`)}
        className="text-xs italic text-surface-500 hover:text-surface-900"
      >
        ↳ Moved &ldquo;{note.reason}&rdquo; to new conversation →{' '}
        <span className="underline font-medium">{note.toTitle}</span>
      </button>
    </div>
  );
}
